import { render, staticRenderFns } from "./goodsDetailsTpl1.vue?vue&type=template&id=23f8f3c9&scoped=true"
import script from "./goodsDetailsTpl1.vue?vue&type=script&lang=js"
export * from "./goodsDetailsTpl1.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailsTpl1.vue?vue&type=style&index=0&id=23f8f3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8f3c9",
  null
  
)

export default component.exports